export const ERROR_KEYS = {
  minimum3: 'Не менее 3 символов',
  minimum2: 'Не менее 2 символов',
  createLogin: 'Используйте символы Aa-Zz, 0-9',
  email: 'Используйте символы Aa-Zz, 0-9, ., -',
  longName: 'Используйте символы Аа-Яя, Aa-Zz, 0-9, пробел, тире',
  phone: 'Ведите данные, используя символы 0-9, (), -',
  minPass: 'Введите пароль, минимум 6 символов',
  newPass: 'Введите новый пароль, минимум 6 символов',
  passwordNoPass: 'Введите новый пароль, минимум 6 символов',
  enterName: 'Введите название',
  s3Folder: 'Используйте символы a-z, 0-9, дефис и точки',
  link: 'Укажите ссылку латиницей'
}
